
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/search/[slug]/[id]",
      function () {
        return require("private-next-pages/search/[slug]/[id].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/search/[slug]/[id]"])
      });
    }
  